<div class="v-preferences fadeIn v-cookies-dialog">
  <div class="v-cookie-header">
    <h4 i18n>Cookie Preferences</h4>
    <img (click)="dialogRef.close()" src="images/ops/close.png" alt="" />
  </div>
  <div class="v-option">
    <span i18n>Necessary Cookies</span>
    <ops-switch [disabled]="true" [ngModel]="true" />
  </div>
  <div class="v-additional-info">
    <p i18n>
      These cookies are essential for you to browse the website and use its features, such as
      accessing secure areas of the site. The necessary cookies can therefore not be turned off.
    </p>
  </div>
  <div class="v-option">
    <span i18n>Performance & Analytics cookies</span>
    <ops-switch [(ngModel)]="isPerformanceCookie" />
  </div>
  <div class="v-additional-info">
    <p i18n>
      Also known as “performance cookies” or “statistics cookies”, these cookies collect information
      about how you use a website, like which pages you visited and which links you clicked on. None
      of this information can be used to identify you. It is all aggregated and, therefore,
      anonymized. Their sole purpose is to improve website functions. This includes cookies from
      third-party analytics services.
    </p>
  </div>
  <div class="v-wrap-btn">
    <p-button i18n (click)="dialogRef.close(isPerformanceCookie)"> Save Preferences </p-button>
  </div>
  <h4 i18n class="link flex gap-1" (click)="showPolicy = !showPolicy">
    Cookie Policy
    <img [ngClass]="{ open: showPolicy }" src="assets/icons/chevron-right.png" alt="expand" />
  </h4>

  @if (showPolicy) {
    <div class="v-cookie-policy ops-scroll fadeIn flex flex-col gap-3">
      <h4 i18n>Introduction</h4>
      <p i18n>
        Welcome to our cookie policy. This policy explains how we use cookies on our website and
        your rights in relation to this. By continuing to use our website, you agree to our use of
        cookies as described in this policy.
      </p>
      <h4 i18n>What are cookies?</h4>
      <p i18n>
        Cookies are small text files that are stored on your device when you visit a website. They
        help to improve your user experience by remembering your preferences and actions, such as
        your login details, or your language preference.
      </p>
      <h4 i18n>Types of cookies we use</h4>
      <p i18n>We use the following types of cookies on our website:</p>
      <ol class="list-inside list-decimal">
        <li i18n>
          <strong>Strictly necessary cookies:</strong> These cookies are essential for the
          functioning of our website and cannot be turned off by the user. They are used to provide
          basic services such as page navigation, access to secure areas of the website, and
          shopping cart functionality.
        </li>
        <li i18n>
          <strong>Performance & Analytics cookies:</strong> These cookies are used to collect
          information about how visitors use our website, such as which pages they visit most often
          and whether they receive error messages. This helps us to improve the performance of our
          website and provide a better user experience.
        </li>
      </ol>
      <h4 i18n>How we use cookies</h4>
      <p i18n>
        We use cookies to provide you with a better user experience on our website. We also use
        cookies to collect information about how visitors use our website, so that we can improve
        the performance and functionality of our website. Additionally, we may use cookies to
        deliver targeted advertising to you based on your interests and browsing behavior.
      </p>
      <h4 i18n>Your cookie choices</h4>
      <p i18n>
        You can control your cookie preferences by adjusting your browser settings. However, please
        note that disabling cookies may prevent you from accessing certain features of our website
        or using some services.
      </p>
      <h4 i18n>Data sharing</h4>
      <p i18n>We do not share your personal data with third parties for advertising purposes.</p>
      <h4 i18n>Changes to this policy</h4>
      <p i18n>
        We may update this policy from time to time to reflect changes in our use of cookies or in
        the applicable laws and regulations. We encourage you to review this policy regularly to
        stay informed about our use of cookies and your rights in relation to this.
      </p>
      <h4 i18n>Contact us</h4>
      <p i18n>
        If you have any questions about our cookie policy, please contact us at
        <strong>mail&#64;cybera.io</strong>.
      </p>
    </div>
  }
</div>
